import {VideoCard} from './components/Video'

export function TabVideo() {
  return (
    <div className='tab-pane fade' id='tab-video' role='tabpanel' aria-labelledby='tab-video-tab'>
      <div className='row ' style={{alignItems: 'stretch'}}>
        <div className='col-12 d-flex'>
          <VideoCard />
        </div>
      </div>
    </div>
  )
}
